import { BOOKING_OPTIONS } from '../Filters.constants';
import { L10N } from '../Filters.l10n';

export const getBookingOptions = (hasOfferName) =>
  BOOKING_OPTIONS.map(({ field, title }) => ({
    field,
    title: field === 'offer' && hasOfferName ? L10N.LABEL_SHOW_ONLY_DEAL : title,
  }));
